<template>
    <div v-if="tp5XcxUserid" class="share-report-page">
        <!--  案例转发数据  -->
        <!-- <div class="project-share-data-wrap">
            &lt;!&ndash; 标题 &ndash;&gt;
            <div class="head-content" style="border-bottom:none;">
                <div class="title" :class="{'t-das':nShowTab!=0}" @click="changeTab(0)">
                    <img class="title-icon" src="@/assets/images/user-share/share-icon.png" alt="">
                    <span>案例转发数据</span>
                </div>
                &lt;!&ndash;                <div class="stop-time">&ndash;&gt;
                &lt;!&ndash;                    截止统计时间：{{ nowDate }}&ndash;&gt;
                &lt;!&ndash;                </div>&ndash;&gt;
                <div class="title" :class="{'t-das':nShowTab!=1}" @click="changeTab(1)">
                    <img class="title-icon" src="@/assets/images/user-share/view.png" alt="">
                    <span>案例阅读数据</span>
                </div>
            </div>
            <div class="head-content" style="padding-top: 10px;">
                <div class="title" :class="{'t-das':nShowTab!=2}" @click="changeTab(2)">
                    <img class="title-icon" src="@/assets/images/user-share/share-icon.png" alt="">
                    <span>口碑转发数据</span>
                </div>
                &lt;!&ndash;                v-if="author"&ndash;&gt;
                <div class="title" :class="{'t-das':nShowTab!=3}" @click="changeTab(3)">
                    <img class="title-icon" src="@/assets/images/user-share/view.png" alt="">
                    <span>口碑阅读数据</span>
                </div>
            </div>
            <div class="stop-time">
                截止统计时间：{{ nowDate }}
            </div>
            &lt;!&ndash;      数据      &ndash;&gt;
            <div class="data-content" v-show="nShowTab==0">
                <div class="data-item" v-for="item in shareDataTotal" :key="item.key">
                    <span class="data-item-value">{{ item.value }}</span>
                    <span>{{ item.title }}</span>
                </div>
            </div>
            <div class="data-content" v-show="nShowTab==1">
                <div class="data-item" v-for="item in viewDataTotal" :key="item.key">
                    <span class="data-item-value">{{ item.value }}</span>
                    <span>{{ item.title }}</span>
                </div>
            </div>

            <div class="data-content" v-show="nShowTab==2">
                <div class="data-item" v-for="item in commentShareData" :key="item.key">
                    <span class="data-item-value">{{ item.value }}</span>
                    <span>{{ item.title }}</span>
                </div>
            </div>

            <div class="data-content" v-show="nShowTab==3">
                <div class="data-item" v-for="item in commentViewData" :key="item.key">
                    <span class="data-item-value">{{ item.value }}</span>
                    <span>{{ item.title }}</span>
                </div>
            </div>
        </div>-->
        <div class="data-panel">
            <div class="case-type">
                <div :class="['type-item',{'type-item-act':caseType == 0}]" @click="cutCaseType(0)">全部案例</div>
                <div :class="['type-item',{'type-item-act':caseType == 1}]" @click="cutCaseType(1)">口碑案例</div>
            </div>
            <div class="content">
                <div class="data-type">
                    <div :class="['type-item',{'type-item-act':dataType == 0}]" @click="cutDataType(0)">转发</div>
                    <div :class="['type-item',{'type-item-act':dataType == 1}]" @click="cutDataType(1)">阅读</div>
                    <div :class="['type-item',{'type-item-act':dataType == 2}]" @click="cutDataType(2)">触达</div>
                    <div :class="['type-item',{'type-item-act':dataType == 3}]" @click="cutDataType(3)">成交</div>
                    <div :class="['type-item',{'type-item-act':dataType == 4}]" @click="cutDataType(4)">成交额</div>
                </div>
                <div class="time-select" @click="isShowTimePopup = true;">
                    {{ startTime }} — {{ endTime }}
                    <img class="icon" v-if="isShowTimePopup" src="@/assets/images/user-share/select_d.png"
                         alt="">
                    <img class="icon" v-else src="@/assets/images/user-share/select_u.png" alt="">
                </div>
                <div class="data-info">
                    <div v-for="(data,index) in dataInfo" :key="index" class="data-item">
                        <span class="value">{{ countUnit(data.value) }}</span>
                        <span class="title">{{ data.title }}</span>
                    </div>
                </div>
            </div>
        </div>
        <Overlay @click.self="overlayClickHidden" :show="isShowTimePopup" class="time-content">
            <!--            时间确认            -->
            <div class="time-content-confirm">
                <div class="time-button">
                    <div v-for="(btn,index) in dateTimeScope" :key="btn.key" class="time-btn-item"
                         :class="{'time-btn-item-active':dateTimeIndex == index}" @click.stop="setSelectTime(index)">
                        {{ btn.title }}
                    </div>
                </div>
                <div v-show="dateTimeIndex == 0">
                    <div class="custom-title">自定义</div>
                    <div class="time-scope">
                        <div @click.stop="selectCustomTime(0)" class="time-item">
                            {{ dateTimeScope[0].value[0] }}
                        </div>
                        <span>至</span>
                        <div @click.stop="selectCustomTime(1)" class="time-item">
                            {{ dateTimeScope[0].value[1] }}
                        </div>
                    </div>
                </div>
                <div class="button-view">
                    <div class="btn" @click.stop="timeSelectRest">重置</div>
                    <div class="btn confirm" @click.stop="timeSelectConfirm">确认</div>
                </div>
            </div>
            <!--            时间选择            -->
            <div v-if="isShowTimePicker" class="time-content-select">
                <DatetimePicker v-model="dateTimeCurrentDate" @cancel="isShowTimePicker = false"
                                @confirm="setCustomTime($event)" :min-date="dataTimeMinDate" :max-date="dataTimeMaxDate"
                                type="date" :formatter="timeFormatter"/>
            </div>
        </Overlay>
        <el-share ref="elShare" v-show="caseType == 0 && dataType == 0"></el-share>
        <el-view ref="elView" v-show="caseType == 0 && dataType == 1"></el-view>
        <el-comment-share ref="elCommentShare" v-show="caseType == 1 && dataType == 0"></el-comment-share>
        <el-comment-view ref="elCommentView" v-show="caseType == 1 && dataType == 1"></el-comment-view>
        <!-- 新增的触达、成交、成交额，通过传参组件内部区分全部案例和口碑案例 -->
        <el-reach ref="elReach" v-show="dataType == 2" :case-type="caseType"></el-reach>
        <el-turnover ref="elTurnover" v-show="dataType == 3 || dataType == 4" :data-type="dataType"
                     :case-type="caseType"></el-turnover>
    </div>
</template>

<script>
import day from "dayjs";
import {Overlay, DatetimePicker} from "vant";
import {mapState} from "vuex";
import elShare from './components/share';
import elView from './components/view';
import elCommentShare from './components/comment/share';
import elCommentView from './components/comment/view';
/* 新增的触达、成交、成交额，通过传参组件内部区分全部案例和口碑案例*/
import elReach from './components/reach';
import elTurnover from './components/turnover';

export default {
    name: "report_useKP",
    components: {
        Overlay,
        DatetimePicker,
        elShare,
        elView,
        elCommentShare,
        elCommentView,
        elReach,
        elTurnover
    },
    data() {
        return {
            caseType: 0, //0-全部案例，1-口碑案例
            dataType: 0, //0-转发，1-阅读，2-触达，3-成交，4-成交额
            startTime: '',
            endTime: '',
            isShowTimePopup: false,
            isShowTimePicker: false,
            dateTimeType: 0, //0-开始时间，1-结束时间
            dateTimeIndex: 0,
            // 时间选择范围
            dateTimeScope: [
                {
                    title: "自定义",
                    value: [
                        day().set('date', 1).format("YYYY.MM.DD"),
                        day().format("YYYY.MM.DD"),
                    ],
                    key: "custom",
                },
                {
                    title: "近7天",
                    value: [
                        day().subtract(7, "day").format("YYYY.MM.DD"),
                        day().format("YYYY.MM.DD"),
                    ],
                    key: "week",
                },
                {
                    title: "近30天",
                    value: [
                        day().subtract(30, "day").format("YYYY.MM.DD"),
                        day().format("YYYY.MM.DD"),
                    ],
                    key: "month",
                },
            ],
            // 时间选择器默认时间
            dateTimeCurrentDate: new Date(),
            // 时间选择器的最小、最大时间
            dataTimeMinDate: day().subtract(10, "year").$d,
            dataTimeMaxDate: new Date(),
            dataInfo: [],
            // nShowTab: 0,
            /*nShowTab: 0,
            // // 当天日期
            nowDate: day().format("YYYY年MM月DD日"),*/
        };
    },
    computed: {
        ...mapState({
            // 权限
            author: (state) => state.userShareData.author,
            // 案例转发数据
            shareDataTotal: (state) => state.userShareData.shareDataTotal,
            // 案例阅读数据
            viewDataTotal: (state) => state.userShareData.shareDataTotalView,
            // 案例成交数据
            caseTurnoverData: (state) => state.userTurnoverData.caseTurnoverData,
            // 案例成交额数据
            caseTurnoverMoneyData: (state) => state.userTurnoverData.caseTurnoverMoneyData,
            // 口碑转发数据
            commentShareData: (state) => state.userShareData.commentShareData,
            // 口碑阅读数据
            commentViewData: (state) => state.userShareData.commentViewData,
            // 口碑成交数据
            commentTurnoverData: (state) => state.userTurnoverData.commentTurnoverData,
            // 口碑成交额数据
            commentTurnoverMoneyData: (state) => state.userTurnoverData.commentTurnoverMoneyData,
            // 用户tp5id
            tp5XcxUserid: (state) => state.userShareData.tp5XcxUserid,

            // 案例触达数据
            caseReachData: (state) => state.userReachData.caseReachData,
            // 口碑触达数据
            commentReachData: (state) => state.userReachData.commentReachData,
        }),
    },
    mounted() {
        $init(() => {
            this.timeInit();
            this.fetchPageData();
        })
    },
    methods: {
        /*changeTab(index) {
            this.nShowTab = index;
        },*/
        fetchPageData() {
            const url = new URL(location);
            // 获取用户ID tp5xcxuserid是和小程序那边约定的key
            this.$store.commit({
                type: "userShareData/SET_USER_ID",
                id: url.searchParams.get("tp5xcxuserid"),
            });
            this.$store.commit({
                type: "userShareDataView/SET_USER_ID",
                id: url.searchParams.get("tp5xcxuserid"),
            });
            // 获取分享总数据
            this.$store.dispatch({
                type: "userShareData/fetchEnterpriseTotalAction",
            });
            // 阅读总数据
            this.$store.dispatch({
                type: "userShareData/fetchViewTotalAction",
            });
            // 评论转发
            this.$store.dispatch({
                type: "userShareData/fetchShareTotalAction",
            });
            // 评论阅读
            this.$store.dispatch({
                type: "userShareData/fetchViewTotalActionC",
            });

            //触达数据（全部/口碑）
            this.$store.dispatch({
                type: "userReachData/getReachData",
                id: url.searchParams.get("tp5xcxuserid"),
            });
            //成交、成交额数据（全部/口碑）
            this.$store.dispatch({
                type: "userTurnoverData/getTurnoverData",
                id: url.searchParams.get("tp5xcxuserid"),
            });

            // 权限检查
            this.$store.dispatch({
                type: "userShareData/fetchViewAuthorAction",
            });
            this.cutDataInfo();
        },
        cutCaseType(type) {
            this.caseType = type;
            this.cutDataInfo();
        },
        cutDataType(type) {
            this.dataType = type;
            this.cutDataInfo();
        },
        cutDataInfo() {
            let start = this.startTime.replaceAll('.', '-');
            let end = this.endTime.replaceAll('.', '-');
            if (this.caseType == 0) {
                if (this.dataType == 0) {
                    this.dataInfo = this.shareDataTotal;
                    this.$refs.elShare && this.$refs.elShare.update(start, end);
                } else if (this.dataType == 1) {
                    this.dataInfo = this.viewDataTotal;
                    this.$refs.elView && this.$refs.elView.update(start, end);
                } else if (this.dataType == 2) {
                    this.dataInfo = this.caseReachData;
                    this.$refs.elReach && this.$refs.elReach.update(start, end);
                } else if (this.dataType == 3) {
                    this.dataInfo = this.caseTurnoverData;
                    this.$refs.elTurnover && this.$refs.elTurnover.update(start, end);
                } else if (this.dataType == 4) {
                    this.dataInfo = this.caseTurnoverMoneyData;
                    this.$refs.elTurnover && this.$refs.elTurnover.update(start, end);
                }
            } else if (this.caseType == 1) {
                if (this.dataType == 0) {
                    this.dataInfo = this.commentShareData;
                    this.$refs.elCommentShare && this.$refs.elCommentShare.update(start, end);
                } else if (this.dataType == 1) {
                    this.dataInfo = this.commentViewData;
                    this.$refs.elCommentView && this.$refs.elCommentView.update(start, end);
                } else if (this.dataType == 2) {
                    this.dataInfo = this.commentReachData;
                    this.$refs.elReach && this.$refs.elReach.update(start, end);
                } else if (this.dataType == 3) {
                    this.dataInfo = this.commentTurnoverData;
                    this.$refs.elTurnover && this.$refs.elTurnover.update(start, end);
                } else if (this.dataType == 4) {
                    this.dataInfo = this.commentTurnoverMoneyData;
                    this.$refs.elTurnover && this.$refs.elTurnover.update(start, end);
                }
            }
        },
        timeFormatter(type, val) {
            if (type === "year") {
                return val + "年";
            }
            if (type === "month") {
                return val + "月";
            }
            if (type === "day") {
                return val + "日";
            }
            return val;
        },
        timeInit() {
            this.startTime = day().set('date', 1).format("YYYY.MM.DD");
            this.endTime = day().format("YYYY.MM.DD");
            this.dateTimeScope[0].value[0] = this.startTime;
            this.dateTimeScope[0].value[1] = this.endTime;
        },
        overlayClickHidden() {
            this.isShowTimePopup = false;
            this.isShowTimePicker = false;
        },
        setSelectTime(index) {
            this.dateTimeIndex = index;
        },
        selectCustomTime(type) {
            if (type == 0) {
                this.dataTimeMinDate = new Date(day().set("year", 2015).set("month", 0).set("date", 1).format("YYYY/MM/DD"));
                this.dataTimeMaxDate = new Date(this.dateTimeScope[0].value[1].replaceAll('.', '/'));
            } else {
                this.dataTimeMinDate = new Date(this.dateTimeScope[0].value[0].replaceAll('.', '/'));
                this.dataTimeMaxDate = new Date();
            }
            this.dateTimeType = type;
            this.dateTimeCurrentDate = new Date(this.dateTimeScope[0].value[this.dateTimeType].replaceAll('.', '/'));
            this.isShowTimePicker = true;
        },
        setCustomTime(e) {
            this.dateTimeScope[0].value[this.dateTimeType] = day(e).format("YYYY.MM.DD");
            this.isShowTimePicker = false;
        },
        timeSelectRest() {
            this.dateTimeIndex = 0;
            this.timeInit();
            this.$forceUpdate();
        },
        timeSelectConfirm() {
            let date = this.dateTimeScope[this.dateTimeIndex].value;
            this.startTime = this.dateTimeScope[this.dateTimeIndex].value[0];
            this.endTime = this.dateTimeScope[this.dateTimeIndex].value[1];
            this.isShowTimePopup = false;
            let start = this.startTime.replaceAll('.', '-');
            let end = this.endTime.replaceAll('.', '-');
            if (this.caseType == 0) {
                if (this.dataType == 0) {
                    this.$refs.elShare.timeSelectConfirmParent(start, end);
                } else if (this.dataType == 1) {
                    this.$refs.elView.timeSelectConfirmParent(start, end);
                } else if (this.dataType == 2) {
                    this.$refs.elReach.timeSelectConfirmParent(start, end);
                } else {
                    this.$refs.elTurnover.timeSelectConfirmParent(start, end);
                }
            } else if (this.caseType == 1) {
                if (this.dataType == 0) {
                    this.$refs.elCommentShare.timeSelectConfirmParent(start, end);
                } else if (this.dataType == 1) {
                    this.$refs.elCommentView.timeSelectConfirmParent(start, end);
                } else if (this.dataType == 2) {
                    this.$refs.elReach.timeSelectConfirmParent(start, end);
                } else {
                    this.$refs.elTurnover.timeSelectConfirmParent(start, end);
                }
            }
        },
        countUnit(num) {
            let orgNum = Number(num || 0);
            let newNum = '';
            if (orgNum > 9999999) {
                newNum = (orgNum / 10000000).toFixed(4) + "kw";
            } else {
                newNum = orgNum;
            }
            /*else if (orgNum > 9999) {
                    newNum = (orgNum / 10000).toFixed(2) + "w";
                }*/

            console.log(typeof num)
            return newNum
        }
    },
};
</script>

<style scoped lang="scss">
@import "report";
</style>

<style lang="scss">
.share-report-page {
    .van-picker__toolbar {
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        border-bottom: 0.01rem #bfbfbf solid;
        height: 0.9rem;
    }

    .van-picker__cancel,
    .van-picker__confirm {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.32rem;
        border-right: 0.01rem #bfbfbf solid;
        color: #323232;
        font-weight: 700;
    }

    .van-picker__confirm {
        color: #338445;
    }

    .van-ellipsis {
        font-size: 0.3rem;
    }
}
</style>
